import { jsxs as f, jsx as m } from "react/jsx-runtime";
import a from "react";
import s, { css as g } from "styled-components";
import { u as v } from "../chunks/useForwardRef.7bf5d172.js";
import { R as h, I as x } from "../chunks/index.cff5baaf.js";
import { _ as y, b as R } from "../chunks/vendor_rango__tokens.38ee67b0.js";
const C = (e) => {
  const o = {
    ms: 1,
    s: 1e3,
    m: 6e4,
    h: 36e5
  }, t = RegExp(/[a-zA-Z]+$/).exec(e);
  return !t || !(t[0] in o) ? null : parseFloat(e) * o[t[0]];
}, c = s(h).withConfig({
  displayName: "Icon",
  componentId: "sc-lw4fo0-0"
})([""]), b = s.button.withConfig({
  displayName: "ChipFilter",
  componentId: "sc-lw4fo0-1"
})(["all:unset;", " display:inline-flex;height:var(--size-5x);padding:var(--spacing-none) var(--spacing-1_5x);gap:var(--spacing-half);justify-content:center;align-items:center;flex-shrink:0;border-radius:var(--border-radius-circular);color:var(--on-selected-label-color);background-color:var(--selected-bg-color);cursor:pointer;opacity:1;transform:scale(1);transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-01);", "{color:var(--on-selected-icon-color);}&:hover{opacity:var(--hover-container);transition-timing-function:var(--curve-productive-entrance);}&:focus-visible{", " outline-offset:2px;}", ""], y, c, R, (e) => e.$closed && g(["opacity:0 !important;transform:scale(0.2);"])), I = a.forwardRef(({
  children: e,
  onClick: o,
  ...r
}, t) => {
  const [n, l] = a.useState(!0), i = v(t);
  return n && /* @__PURE__ */ f(b, { $closed: !n, ref: i, onClick: (u) => {
    const p = getComputedStyle(i.current).getPropertyValue("transition-duration"), d = C(p);
    l(!1), setTimeout(() => {
      o && o(u);
    }, d);
  }, "data-testid": "rango-chip-filter", "data-rango-component": "rango-chip-filter", "data-is-rango": !0, ...r, children: [
    e,
    /* @__PURE__ */ m(c, { icon: "CloseLine", size: x.SM })
  ] });
});
I.displayName = "RangoChipFilter";
export {
  I as RangoChipFilter
};
